/* unplugin-vue-components disabled */import { render } from "./CoverImage.vue?vue&type=template&id=47426d4c&ts=true"
import script from "./CoverImage.vue?vue&type=script&lang=ts"
export * from "./CoverImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__